var BrowseErrorPresenter;

module.exports = BrowseErrorPresenter = (function() {
  function BrowseErrorPresenter() {}

  BrowseErrorPresenter.prototype.toHash = function() {
    var aClose, aOpen, breakline, category, href, isClearanceSelected, isPriceFilterSelected, queryParams;
    href = window.location.href;
    aOpen = "<a href='" + href + "'>";
    aClose = "</a>";
    breakline = "<br>";
    queryParams = Groupon.Utils.unparam();
    isPriceFilterSelected = ((queryParams != null ? queryParams.minPrice : void 0) != null) || ((queryParams != null ? queryParams.maxPrice : void 0) != null);
    isClearanceSelected = (queryParams != null ? queryParams.discount : void 0) === "gg-clearance";
    if (isPriceFilterSelected) {
      category = (queryParams != null ? queryParams.category : void 0) || 'all';
      href = "/goods?category=" + category;
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.price_range_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    } else if (isClearanceSelected) {
      href = "/goods?category=all&discount=gg-clearance";
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.clearance_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        })
      };
    } else {
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    }
  };

  return BrowseErrorPresenter;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvcHJlc2VudGVycy9lcnJvci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hYnNoYXJtYS9uYXBpc3RyYW5vL2J1aWxkLzE0ODY2NzU2MjQyNzQtNzQzNy9zdGFnaW5nLXBlcmYtMjAxNy4wMi4wOV8wMC4zNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9wcmVzZW50ZXJzL2Vycm9yLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQXVCOzs7aUNBQ3JCLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUEsR0FBTyxNQUFNLENBQUMsUUFBUSxDQUFDO0lBQ3ZCLEtBQUEsR0FBUSxXQUFBLEdBQVksSUFBWixHQUFpQjtJQUN6QixNQUFBLEdBQVM7SUFDVCxTQUFBLEdBQVk7SUFDWixXQUFBLEdBQWMsT0FBTyxDQUFDLEtBQUssQ0FBQyxPQUFkLENBQUE7SUFFZCxxQkFBQSxHQUF3QiwrREFBQSxJQUEwQjtJQUNsRCxtQkFBQSwwQkFBc0IsV0FBVyxDQUFFLGtCQUFiLEtBQXlCO0lBQy9DLElBQUcscUJBQUg7TUFDRSxRQUFBLDBCQUFXLFdBQVcsQ0FBRSxrQkFBYixJQUF5QjtNQUNwQyxJQUFBLEdBQU8sa0JBQUEsR0FBbUI7TUFDMUIsS0FBQSxHQUFRLFdBQUEsR0FBWSxJQUFaLEdBQWlCO2FBQ3pCO1FBQUEsb0JBQUEsRUFBc0IsSUFBSSxDQUFDLFNBQUwsQ0FBZSwyREFBZixDQUF0QjtRQUNBLHdCQUFBLEVBQTBCLElBQUksQ0FBQyxTQUFMLENBQWUsMkVBQWYsRUFBNEY7VUFBRSxPQUFBLEtBQUY7VUFBUyxRQUFBLE1BQVQ7U0FBNUYsQ0FEMUI7UUFFQSx3QkFBQSxFQUEwQixJQUFJLENBQUMsU0FBTCxDQUFlLCtEQUFmLEVBQWdGO1VBQUUsV0FBQSxTQUFGO1NBQWhGLENBRjFCO1FBSkY7S0FBQSxNQU9LLElBQUcsbUJBQUg7TUFDSCxJQUFBLEdBQU87TUFDUCxLQUFBLEdBQVEsV0FBQSxHQUFZLElBQVosR0FBaUI7YUFDekI7UUFBQSxvQkFBQSxFQUFzQixJQUFJLENBQUMsU0FBTCxDQUFlLDJEQUFmLENBQXRCO1FBQ0Esd0JBQUEsRUFBMEIsSUFBSSxDQUFDLFNBQUwsQ0FBZSx5RUFBZixFQUEwRjtVQUFFLE9BQUEsS0FBRjtVQUFTLFFBQUEsTUFBVDtTQUExRixDQUQxQjtRQUhHO0tBQUEsTUFBQTthQU1IO1FBQUEsb0JBQUEsRUFBc0IsSUFBSSxDQUFDLFNBQUwsQ0FBZSwyREFBZixDQUF0QjtRQUNBLHdCQUFBLEVBQTBCLElBQUksQ0FBQyxTQUFMLENBQWUsK0RBQWYsRUFBZ0Y7VUFBRSxPQUFBLEtBQUY7VUFBUyxRQUFBLE1BQVQ7U0FBaEYsQ0FEMUI7UUFFQSx3QkFBQSxFQUEwQixJQUFJLENBQUMsU0FBTCxDQUFlLCtEQUFmLEVBQWdGO1VBQUUsV0FBQSxTQUFGO1NBQWhGLENBRjFCO1FBTkc7O0VBaEJDIn0=
